
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from './controlador';
    import { ControladorSeccion as ModeloControladorPrincipial } from '../controlador';
    import cliente from './editar-cliente.vue';
    import envio from './editar-envio.vue';
    import items from './editar-items.vue';
    import pagos from './editar-pagos.vue';
    import barra from './barra-lateral.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            cliente,
            envio,
            items,
            pagos,
            barra,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Pedido() { return this.Controlador.Pedido; }

        @Prop()
        public ControladorPrincipal: ModeloControladorPrincipial;



        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            let data = this.ControladorPrincipal.ObtenerDatos();

            this.Controlador.Iniciar( data, { tipo: this.ControladorPrincipal.Tipo } );
            //this.Eventos.push( this.Controlador.onRecargar.subscribe( () =>{this.Refrescar();            } ) );

            this.$nextTick( () =>
            {
                //document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );

        }



        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        GuardarYContinuar()
        {
            this.Controlador.GuardarYContinuar();
        }
    }
